// src/components/HeadlineCard.tsx
import React, { memo } from "react";
import { HeadlineFlowItemData } from '../data/headlineData'; 

interface HeadlineCardProps {
  item: HeadlineFlowItemData;
  scale: number;
  opacity: number;
  topInColumn: number; // Top position relative to its scrolling parent column
  cardWidth: number;   // The target width when scale is 1.0
  zIndex: number;
}

const HeadlineCard: React.FC<HeadlineCardProps> = ({
  item,
  scale,
  opacity,
  topInColumn,
  cardWidth,
  zIndex,
}) => {
  const cardStyle: React.CSSProperties = {
    position: 'absolute',
    // Left is 0 because its parent column is already centered and sized
    left: '0', 
    width: `${cardWidth}px`, // Card takes the full passed width before scaling
    transformOrigin: 'center center', 
    transform: `scale(${scale.toFixed(3)})`, // Only scale is needed here
    opacity: opacity.toFixed(3),
    top: `${topInColumn}px`, 
    zIndex: zIndex,
    transition: 'transform 0.15s ease-out, opacity 0.15s ease-out, top 0.15s ease-out', // Slightly softer transition
    willChange: 'transform, opacity, top',
  };

  const imageStyle: React.CSSProperties = {
    display: 'block',
    width: '100%',   
    height: 'auto',   
    borderRadius: '8px', 
    boxShadow: '0px 6px 20px rgba(0,0,0,0.12)', // Slightly enhanced shadow
  };

  const altText = `${item.publication} - ${item.headline}`;

  return (
    <div style={cardStyle}>
      <img
        src={item.imageSrc}
        alt={altText}
        style={imageStyle}
        loading="lazy"
      />
    </div>
  );
};

export default memo (HeadlineCard);
